/* Toggle dropdown list
 * https://gist.github.com/slavapas/593e8e50cf4cc16ac972afcbad4f70c8
 */
const menuOpenEvent = new Event('onMenuOpenEvent');
var navMenuDiv = document.getElementById("nav-content");
var navMenu = document.getElementById("nav-toggle");
var menuMainItems = document.getElementsByClassName("dropdown-menu");
var burger = document.getElementById("burger-container");
var burgerText = document.getElementById("burger-text");
var menu = document.getElementById("header");

var resizeEventThrottled = false;

document.onclick = navClickCheck;
document.addEventListener("scroll", shrinkOnScroll);

function navClickCheck(e) {
    var target = (e && e.target) || (event && event.srcElement);
    //Nav Menu
    if (!targetIsWithinParentElement(target, navMenuDiv)) {
        // click NOT on the menu
        if (targetIsWithinParentElement(target, navMenu)) {
            // click on the link
            var isHidden = toggleHidden(navMenuDiv);

            if (isHidden) {
                burger.classList.remove("burger-open");
                burgerText.innerHTML = burgerText.dataset.openText;
                document.body.classList.remove("prevent-scroll");
                setTimeout(() => document.body.classList.remove("nav-menu-opened"), 50);
            } else {
                burger.classList.add("burger-open");
                burgerText.innerHTML = burgerText.dataset.closeText;
                document.body.classList.add("prevent-scroll");
                document.body.classList.add("nav-menu-opened");
                window.dispatchEvent(menuOpenEvent);
            }
        } else {
            // click both outside link and outside menu, hide menu
            hideAllExpanded();
        }
    }
    else if (target.classList.contains("dropdown-toggle") && target.nextElementSibling && target.nextElementSibling.classList.contains("dropdown-menu")) {
        if (target.nextElementSibling.classList.contains("hidden")) {
            hideAllExpanded();
        }
        toggleHidden(target.nextElementSibling);
    }
}

function targetIsWithinParentElement(t, elm) {
    while (t.parentNode) {
        if (t == elm) {
            return true;
        }
        t = t.parentNode;
    }
    return false;
}

function hideAllExpanded() {
    var menu = document.getElementsByClassName("dropdown");

    for (var i = 0; i < menuMainItems.length; i++) {
        menuMainItems[i].classList.add("hidden");
        menu[i].classList.remove("open-chev");
    }
}

function toggleHidden(element) {
    if (element.classList.contains("hidden")) {
        if (!element.parentNode.classList.contains('menu-container-inner')) {
            element.parentNode.classList.add("open-chev");
        }
        element.classList.remove("hidden");
        return false;
    } else {
        element.parentNode.classList.remove("open-chev");
        element.classList.add("hidden");
        return true;
    }
}

var scrollPosY = window.pageYOffset,
    isShrinked = false,
    menuShrinkScrollYThreshold = 50;
function shrinkOnScroll() {
    scrollPosY = window.pageYOffset;

    if (scrollPosY > menuShrinkScrollYThreshold && !isShrinked) {
        menu.classList.add("menu-scroll-shrink");
        isShrinked = true;
    } else if (scrollPosY <= menuShrinkScrollYThreshold && isShrinked) {
        menu.classList.remove("menu-scroll-shrink");
        isShrinked = false;
    }
}

window.addEventListener('load', () => {
    if (window.tippy) {
        tippy('[data-tippy-content]:not([data-tippy-content=""])', {
            trigger: 'mouseenter focus click'
        });
    }

    window.addEventListener('resize', function () {
        if (!resizeEventThrottled) {
            // If the user resizes the screen to the desktop resolution while the burger menu is opened, remove css classes to prevent nav-menu being stuck in mobile view
            if (window.matchMedia("(min-width: 1024px)").matches) {
                document.body.classList.remove("prevent-scroll");
                document.body.classList.remove("nav-menu-opened");
                burger.classList.remove("burger-open");
                burgerText.innerHTML = burgerText.dataset.openText;
                navMenuDiv.classList.add("hidden");
            }

            // Quick optimization for the resize event to be called only every N seconds instead of every frame (very performance-heavy)
            resizeEventThrottled = true;
            setTimeout(() => resizeEventThrottled = false, 100);
        }
    });
});
